<script setup lang="ts">
import SurveyBuilt from "@/survey/components/SurveyBuilt.vue";
import {useRoute} from "vue-router";
import Icon from "@/core/components/icon/Icon.vue";
import CustomerRemoteCertification
    from "@/customer/components/customer-remote-certification/CustomerRemoteCertification.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {onMounted, ref} from "vue";
import {healthcenterUserApi} from "@/container";

const route = useRoute();

const modalVisible = ref(false);
const userToCertify = ref();

onMounted(() => {
    const firstName = (route.query.name as string).split(' ')[0];
    const lastName = (route.query.name as string).split(' ')[1];
    healthcenterUserApi().index({certification_status: "pending"})
        .then(response => {
            if (response.length > 0) {
                userToCertify.value = response.find(user =>
                    user.last_name === lastName && user.first_name === firstName
                );
            }
        });
});

</script>

<template>
  <div class="gradient px-6 py-4">
    <div class="flex flex-row justify-space-between">
      <div class="flex flex-row items-center gap-5">
        <button
          class="flex items-center cursor-pointer hover:opacity-75"
          @click="$router.go(-1)"
        >
          <icon
            name="mdi-close"
            class="text-white"
            :size="30"
          />
        </button>
        <h2 class="text-white font-medium">
          Ce questionnaire a été rempli par <span v-if="$route.query.name" class="font-bold">{{
            $route.query.name
          }}</span>
          <span v-else>un patient en attente de certification</span>. Vous pouvez débloquer son accès à l'application
          Apodis en certifiant son numéro de téléphone depuis sa fiche patient.
        </h2>
        <BaseButton @click.stop="modalVisible = true">
          Débloquer l'accès
        </BaseButton>
      </div>
    </div>
  </div>
  <SurveyBuilt v-if="route.params.instanceId" :instance-id="Number(route.params.instanceId)" />
  <customer-remote-certification
    v-if="modalVisible && userToCertify"
    :user="userToCertify"
    @close="modalVisible=false;"
  />
</template>
